export class Company {
  CompCode;
  CName;
  EName;
  Photo;
  PhotoFile;
  LetterHead;
  constructor() {
    this.CompCode = "";
    this.CName = "";
    this.EName = "";
    this.Photo = "";
    this.PhotoFile = "";
    this.LetterHead = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Company.js